module.exports = __webpack_public_path__ + "img/manager.485580b7.jpg";